module.exports = __webpack_public_path__ + "static/media/knowbie@3x.5e5707de.jpg";